import { render, staticRenderFns } from "./LocationLabReportsList.vue?vue&type=template&id=b6f7df3e&scoped=true&"
import script from "./LocationLabReportsList.vue?vue&type=script&lang=js&"
export * from "./LocationLabReportsList.vue?vue&type=script&lang=js&"
import style0 from "./LocationLabReportsList.vue?vue&type=style&index=0&id=b6f7df3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f7df3e",
  null
  
)

export default component.exports